<script setup lang="ts">
import NamaIcon from "@/components/icons/NamaIcon.vue";
import NamaLabel from "@/components/NamaLabel.vue";

defineProps<{
  downloadUrl: string;
  btnSize?: string;
  btnClass?: string;
  btnColor?: string;
}>();

</script>

<template>
  <q-btn round dense flat icon="keyboard_arrow_down" :size="btnSize ?? 'sm'" :class="btnClass" :color="btnColor" @click.stop>
    <q-menu>
      <q-list dense>
        <q-item clickable v-close-popup :href="downloadUrl" tag="a" download>
          <q-item-section>
            <NamaLabel text="download">
              <NamaIcon defaultIcon="download" class="active-primary" size="xs"/>
            </NamaLabel>
          </q-item-section>
        </q-item>
      </q-list>
    </q-menu>
  </q-btn>
</template>
